import { cn } from "ui";

import { formatDuration } from "src/lib/formatMetrics";

interface StravaActivityZoneBucket {
  min: number;
  max: number;
  time: number;
}

export interface StravaActivityZone {
  id: string;
  type: string;
  score: number | null;
  sensorBased: boolean;
  customZones: boolean | null;
  max: number | null;
  points: number | null;
  distributionBuckets: StravaActivityZoneBucket[] | null;
}

const ZONE_COLORS = [
  "bg-emerald-500",
  "bg-lime-500",
  "bg-yellow-500",
  "bg-orange-500",
  "bg-red-500",
];

const TYPE_LABELS: Record<string, string> = {
  heartrate: "Heart Rate Zones",
  power: "Power Zones",
  pace: "Pace Zones",
};

export function StravaActivityZonesTypeSection(props: {
  zone: StravaActivityZone;
}) {
  const buckets = props.zone.distributionBuckets ?? [];
  const maxTime = Math.max(
    ...buckets.map((bucket) => {
      return bucket.time;
    }),
  );
  const label = TYPE_LABELS[props.zone.type] ?? props.zone.type;

  return (
    <div className="space-y-2">
      <h5 className="text-xs font-medium text-muted-foreground">{label}</h5>
      <div className="space-y-1.5">
        {buckets.map((bucket, index) => {
          const widthPercent = maxTime > 0 ? (bucket.time / maxTime) * 100 : 0;
          const color =
            ZONE_COLORS[index] ?? ZONE_COLORS[ZONE_COLORS.length - 1];
          const timeLabel = formatDuration(bucket.time) ?? "0s";

          return (
            <div key={index} className="flex items-center gap-2">
              <span className="text-xs text-muted-foreground w-12 shrink-0">
                Zone {index + 1}
              </span>
              <div className="flex-1 h-5 bg-muted rounded-sm overflow-hidden">
                <div
                  className={cn("h-full rounded-sm", color)}
                  style={{ width: `${Math.max(widthPercent, 2)}%` }}
                />
              </div>
              <span className="text-xs tabular-nums w-14 text-right shrink-0">
                {timeLabel}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
